import { useLaboratory } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormButton, FormInputField, Modal, TextAreaField } from '@ui'
import { getError, showToast } from '@util'
import { FormProvider, useForm } from 'react-hook-form'
import useFormPersist from 'react-hook-form-persist'
import * as yup from 'yup'

type Props = {
  onClose: () => void
}

export const addLaboratorySchema = yup.object({
  category: yup.string().required('Category is required'),
  description: yup.string(),
  name: yup.string().required('Name is required'),
  price: yup.number().required('Price is required')
})

export const AddLaboratory = ({ onClose }: Props) => {
  const methods = useForm({ resolver: yupResolver(addLaboratorySchema) })
  const { createLaboratory } = useLaboratory()

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { isSubmitting }
  } = methods

  const { clear } = useFormPersist('addLab', { setValue, storage: window.localStorage, watch })

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          ...data,
          default: false
        },
        type: 'laboratories'
      }
    }
    try {
      await createLaboratory(payload)
      showToast('Laboratory added successfully')
      handleClose()
    } catch (error: any) {
      getError(error)
    }
  }

  const handleClose = () => {
    onClose()
    reset()
    clear()
  }

  return (
    <FormProvider {...methods}>
      <Modal onClose={handleClose} reset={reset} title="Add Laboratory Test">
        <form className="flex flex-col gap-4 overflow-auto pb-0" onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-4 overflow-auto p-6 pb-0">
            <div className="">
              <FormInputField label="Name" name="name" placeholder="" />
            </div>
            <div className="">
              <FormInputField label="Category" name="category" placeholder="" />
            </div>
            <div className="">
              <FormInputField label="Price" name="price" placeholder="" type="number" />
            </div>
            <div className="">
              <TextAreaField label="Description" name="description" />
            </div>
          </div>
          <FormButton isLoading={isSubmitting} onClose={handleClose} />
        </form>
      </Modal>
    </FormProvider>
  )
}
